import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiTypography: {
      h3: {
        fontSize: '1.45em',
        fontWeight: 500,
        textAlign: 'center',
        letterSpacing: 0.2,
        lineHeight: '1.2em',
        color: currentTheme.palette.tertiary.darkGreen,
      },
      h4: {
        fontSize: '1.7em',
        color: currentTheme.palette.primary.main,
      },
      h5: {
        fontSize: '1.15em',
        letterSpacing: 0.5,
        color: currentTheme.palette.tertiary.lightGrey,
      },
      h6: {
        fontSize: '1.15em',
        fontWeight: 400,
        letterSpacing: 0.5,
        color: currentTheme.palette.tertiary.lightGrey,
      },
    },
    MuiButton: {
      contained: {
        '&.Mui-disabled': {
          color: currentTheme.palette.white,
        },
      },
    },
  },
}))
